$(window).load(function () {
  // ---------------------------------------------------------------------------------------------
  // Getting main site menu ----------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------------
  // getMenu(); FIXME uncomment this line of code for doing menu working
  // ---------------------------------------------------------------------------------------------

  // ---------------------------------------------------------------------------------------------
  // Calculate top gap for grey-background -------------------------------------------------------
  // ---------------------------------------------------------------------------------------------
  var fullheaderHeight = $("#shopify-section-header").height();
  var breadcrumbs = $("#breadcrumbs").outerHeight();

  $(".grey-background").css("margin-top", fullheaderHeight + breadcrumbs + 20);
  // ---------------------------------------------------------------------------------------------

  // ---------------------------------------------------------------------------------------------
  // Open/Close mobile menu ----------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------------
  $(".toggle-nav").click(function () {
    toggleNav();
  });
  // ---------------------------------------------------------------------------------------------
});

function getMenu() {
  //const storeHandle = Shopify.shop.replace(".myshopify.com", "");
  //const menuDataUrl = `https://images.nexusapp.co/data/navigation/${storeHandle}.json`;

  $.get(
    "https://apines.hktemas.com/api/shopify-category-menu",

    { domain: "https://myxlshop.myshopify.com/" }
  )

    .done(function (data) {
      $("#jnix-menu").html(data.full);
      $("#full-menu").html(data.full);

      // Temporary hidden ------------------------------------------------------------------------
      // $("#site-menu ul.default-menu").append(data.mobile);
      // -----------------------------------------------------------------------------------------

      var firstImemInMenu = $(".navigation-menu li").first();
      $(".category-container").hide();

      $(".menu-category-item").mouseover(function () {
        $(this).find("i").removeClass("down-arrow");
        $(this).find("i").addClass("up-arrow");
        $(".category-container").show();
        $(".category-menu-items").show();
        $(".sub-catecories").empty();
        $(".grey-background").show();
        firstImemInMenu
          .find(".sub-container")
          .clone()
          .prependTo($(".sub-catecories"));
        firstImemInMenu
          .addClass("active")
          .append("<div class='arrow-up'></div>");
        $(".sub-catecories .sub-container").show();
        $("body").css({ overflow: "hidden", "margin-right": "15px" });
        $(".sub-container.drop-menu-sub-category").css({
          "overflow-y": "auto",
          "overflow-x": "hidden",
          "max-height": "60vh",
        });
      });

      $(".navigation-menu li").click(function () {
        $(".navigation-menu li").removeClass("active");
        $(".arrow-up").remove();
        $(this).addClass("active").append("<div class='arrow-up'></div>");

        $(".sub-catecories").empty();
        $(this).find(".sub-container").clone().prependTo($(".sub-catecories"));
        $(".sub-catecories").show();
        $(".sub-catecories .sub-container").show();
      });

      $(".category-container").mouseover(function () {
        $(".category-container").show();
        $(".category-menu-items").show();
        $(".grey-background").show();
        $(".sub-catecories .sub-container").show();
      });

      $("#btn-category").mouseleave(function () {
        $(".category-container").hide();
        $(".category-menu-items").hide();
        $(".arrow-up").remove();
        $(".grey-background").hide();
        $(".menu-category-item").find("i").removeClass("up-arrow");
        $(".menu-category-item").find("i").addClass("down-arrow");
        $("body").css({ overflow: "auto", "margin-right": "0px" });
      });

      // -----------------------------------------------------------------------------------------
      // script for hightlighting active menu item -----------------------------------------------
      // -----------------------------------------------------------------------------------------
      var currentHref = window.location.href.split("/").slice(3).join("/"); // path
      var tagA = $("#site-menu a[href$='" + currentHref + "']"); // current menu item
      tagA.css({
        "font-size": "16px",
        "font-weight": "bold",
      });
      tagA.parents("ul").css("display", "block");
      // -----------------------------------------------------------------------------------------
    })
    .fail(function () {
      console.log("error");
    });
}

function toggleNav() {
  if ($("#site-wrapper").hasClass("show-nav")) {
    $("#site-wrapper").removeClass("show-nav");
    $("#site-menu").css("position", "fixed");
  } else {
    $("#site-wrapper").addClass("show-nav");
    $("#site-menu").css("position", "absolute");
  }
}

$(window).load(function () {
  if ($("#recently-viewed-products").is(":empty")) {
    $(".itemonderp").hide();
  }

  var urlsort = window.location.search;
  var urlPath = window.location.pathname;
  var siteMap = "/apps/sitemap";

  if (urlPath === siteMap) {
    console.log("sitemap app");
    $("#content").addClass("container");
  }

  var popularSort = "?sort_by=best-selling/?top10";
  var countProducts = $(".showtop10").length;

  if (urlsort === popularSort) {
    $(".showtop10").slice(10, countProducts).hide();
  }

  $(".sort-show").click(function () {
    $(".sort-container").toggle(function () {
      console.log("dd");
    });
  });
  $(".filter-show").click(function () {
    $(".filters").toggle();
  });

  // ---------------------------------------------------------------------------------------------
  // Show cart pop-up when cart icon was clicked  ------------------------------------------------
  // ---------------------------------------------------------------------------------------------
  $(".show-cart-popup").click(function () {
    $(".cart-popup").toggle();
  });

  $(document).click(function (e) {
    if (!$(e.target).parents().andSelf().is(".show-cart-popup")) {
      $(".cart-popup").hide();
    }
  });

  $(".cart-popup").click(function (e) {
    e.stopPropagation();
  });
  // ---------------------------------------------------------------------------------------------

  $(".product-info-container img").prependTo($(".product-images"));

  if ($(".product-images").is(":empty")) {
    $(".images-more-less-section").hide();
    $(".product-images").hide();
  }

  // ---------------------------------------------------------------------------------------------
  //   Remove empty div --------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------------
  $(".tab-pane br").each(function () {
    if ($(this).prev().not("br") && $(this).next().is("br")) {
      $(this).remove();
    }
  });

  var emptyP = $(".tab-pane p");
  var emptyH2 = $(".tab-pane h2");

  emptyP.each(function () {
    if ($(this).text().trim().length === 0) {
      $(this).remove();
    }
  });

  emptyH2.each(function () {
    if ($(this).text().trim().length === 0) {
      $(this).remove();
    }
  });
  // ---------------------------------------------------------------------------------------------

  // ---------------------------------------------------------------------------------------------
  // check image quantity (product description) --------------------------------------------------
  // ---------------------------------------------------------------------------------------------
  if ($(".product-images img").length > 1) {
    $(".product-images img:not(:first)").hide();
    $("#show-images-btn").show();
  } else if ($(".product-images img") == 1) {
    $("#show-images-btn").hide();
  } else {
    $(".product-images").hide();
  }
  // ---------------------------------------------------------------------------------------------

  // ---------------------------------------------------------------------------------------------
  // click show more/less images -----------------------------------------------------------------
  // ---------------------------------------------------------------------------------------------
  $("#show-images-btn").on("click", function () {
    $(".product-images img").show();
    $(this).hide();
    $("#hide-images-btn").show();
  });

  $("#hide-images-btn").on("click", function () {
    $(".product-images img:not(:first)").hide();
    $(this).hide();
    $("#show-images-btn").show();

    $("html, body").animate(
      {
        scrollTop: $("#show-images-btn").offset().top - 250,
      },
      500
    );
  });
  // ---------------------------------------------------------------------------------------------
});

$(window).ready(function () {
  function cutLongString(element, count_lit) {
    var text = element.html();
    var all_len = text ? text.length : null;
    var new_text;

    if (all_len > count_lit) {
      new_text = text.substr(0, count_lit - 3) + "...";
    }
    element.html(new_text);
  }

  $(".expandablepp h2").first().css("font-size", "22px");

  var first_p = $(".expandablepp p").first();
  var first_div = $(".expandablepp div").first();
  var first_ol = $(".expandablepp ol").first();
  var second_p = $(".expandablepp p").eq(1);
  var n1 = first_p[0] ? first_p[0].textContent.length : null;
  var n2 = second_p[0] ? second_p[0].textContent.length : null;
  var n3 = first_div[0] ? first_div[0].textContent.length : null;

  if (n1 > 10) {
    first_p.css("font-size", "19px");
    cutLongString($(first_p.clone().prependTo(".copy-text")), 230);
    $(".copy-text p").append(function (indx, val) {
      return '<a class="gototab"  style="color: #226cb0; cursor: pointer;">Lees meer</a>';
    });
  } else if (n2 > 10) {
    second_p.css("font-size", "19px");

    cutLongString($(second_p.clone().prependTo(".copy-text")), 230);
    $(".copy-text p").append(function (indx, val) {
      return '<a class="gototab"  style="color: #226cb0; cursor: pointer;">Lees meer</a>';
    });
  } else if (n3 > 10) {
    first_div.css("font-size", "19px");
    cutLongString($(first_div.clone().prependTo(".copy-text")), 230);
    $(".copy-text div").append(function (indx, val) {
      return '<a class="gototab"  style="color: #226cb0; cursor: pointer;">Lees meer</a>';
    });
  } else {
    first_ol.css("font-size", "19px");
    cutLongString($(first_ol.clone().prependTo(".copy-text")), 230);
    $(".copy-text ol").append(function (indx, val) {
      return '<a class="gototab"  style="color: #226cb0; cursor: pointer;">Lees meer</a>';
    });
  }

  var scrollTop = $(".product-info-container").offset()
    ? $(".product-info-container").offset().top - 100
    : null;
  $(".gototab").click(function () {
    $(document).scrollTop(scrollTop);
  });
});

//lang--------------------------------------------------------------------------------------------
(function ($, window, document, undefined) {
  "use strict";

  var $html = $("html");

  $html.on("click.ui.dropdown", ".js-dropdown", function (e) {
    e.preventDefault();
    $(this).toggleClass("is-open");
  });

  $html.on(
    "click.ui.dropdown",
    ".js-dropdown [data-dropdown-value]",
    function (e) {
      e.preventDefault();
      var $item = $(this);
      var $dropdown = $item.parents(".js-dropdown");
      $dropdown.find(".js-dropdown__input").val($item.data("dropdown-value"));
      $dropdown.find(".js-dropdown__current").text($item.text());
    }
  );

  $html.on("click.ui.dropdown", function (e) {
    var $target = $(e.target);
    if (!$target.parents().hasClass("js-dropdown")) {
      $(".js-dropdown").removeClass("is-open");
    }
  });
})(jQuery, window, document);
//lang end----------------------------------------------------------------------------------------

$(document).ready(function () {
  $(".closediv").click(function () {
    $("#makeachoice").css("display", "none");
  });
});

$(document).ready(function () {
  $(".cart-page-form .medium-green-btn").on("click", function (e) {
    setTimeout(() => {
      window.location.reload();
    }, 2000);
  });

  // Quick-links ---------------------------------------------------------------------------------
  $(".quick-links .clickable-bl").on("click", function (e) {
    e.preventDefault();
    $(".backdrop").css("display", "block");
    $(this).next().slideDown(300).show();
  });
  // ---------------------------------------------------------------------------------------------
  $("#quantity").on("change", function (e) {
    e.preventDefault();
    var selectedOption = $("#quantity option:selected");
    if (selectedOption.hasClass("changeable-option")) {
      $(".quantity-popup").css("display", "flex");
    }
  });
  // ---------------------------------------------------------------------------------------------

  // Close BTN, backdrop clicked -----------------------------------------------------------------
  $(".backdrop, .close-btn, .close-popup").on("click", function (e) {
    e.preventDefault();
    $(".backdrop").css("display", "none");
    $(".popup-window").css("display", "none");
  });
  // ---------------------------------------------------------------------------------------------

  // ---------------------------------------------------------------------------------------------
  // Change quantity product items with small popup ----------------------------------------------
  // ---------------------------------------------------------------------------------------------
  $("#submitNewQuantity").on("click", function (e) {
    e.preventDefault();
    var newQuantityVal = $("#newQuantity")[0].value || "1";

    $("#quantity option:last-child").val(newQuantityVal).text(newQuantityVal);

    $(".popup-window").css("display", "none");
  });
});
